module.exports = __webpack_public_path__ + "img/special-bg-stars.89aa1c04.png";